import React from "react";
import AdminPageSection from "../sections/AdminPageSection/Content";
const AdminDashbordPage = () => {
  return <AdminPageSection />;
};

export default AdminDashbordPage;
